import moment from 'moment';
import React, { memo } from 'react';

type CreatedCellProps = {
  createdAt: string;
};

export default memo(function CreatedCell({ createdAt }: CreatedCellProps) {
  return (
    <span className="time-state">
      {moment(createdAt).format('MMM DD, YYYY')}
    </span>
  );
});
